export default __webpack_public_path__ + "static/media/SideBarArrowRight.74fa0d55.svg";